/**
 * "Connect an AI client to your workspace" — Guides section (ADR-0074).
 * Composes the MCP connect flow (mint a token → add the server to the client →
 * verify the tools appear). Links to the canonical MCP pages.
 */
import type { DocPageContent } from '../types';

export const GUIDES_CONNECT_MCP_PAGE: DocPageContent = {
  slug: 'guides/connect-mcp',
  titleKey: 'docs.guides.mcp.title',
  descriptionKey: 'docs.guides.mcp.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.mcp.lead' },

    { kind: 'heading', level: 2, id: 'clients', textKey: 'docs.guides.mcp.clients.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.mcp.clients.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.guides.mcp.client.claude',
        'docs.guides.mcp.client.cursor',
        'docs.guides.mcp.client.chatgpt',
      ],
    },

    { kind: 'heading', level: 2, id: 'steps', textKey: 'docs.guides.mcp.steps.heading' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.guides.mcp.step.token.title',
          textKey: 'docs.guides.mcp.step.token.text',
        },
        { titleKey: 'docs.guides.mcp.step.add.title', textKey: 'docs.guides.mcp.step.add.text' },
        {
          titleKey: 'docs.guides.mcp.step.authorize.title',
          textKey: 'docs.guides.mcp.step.authorize.text',
        },
        {
          titleKey: 'docs.guides.mcp.step.verify.title',
          textKey: 'docs.guides.mcp.step.verify.text',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.guides.mcp.security.title',
      textKey: 'docs.guides.mcp.security.body',
      links: {
        auth: {
          target: { docSlug: 'mcp/authentication' },
          labelKey: 'docs.guides.mcp.security.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.mcp.related.connect.title',
          textKey: 'docs.guides.mcp.related.connect.text',
          to: { docSlug: 'mcp/connect' },
        },
        {
          titleKey: 'docs.guides.mcp.related.tools.title',
          textKey: 'docs.guides.mcp.related.tools.text',
          to: { docSlug: 'mcp/tools' },
        },
      ],
    },
  ],
};
